import { useAccessControl } from "@/hooks/useAccessControl";
import { AppLayout } from "@/components/layout/AppLayout";
import { PageHeader } from "@/components/layout/PageHeader";
import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";

const WelcomeMessageSettingsPage = () => {
  const { isTenantAdmin } = useAccessControl();

  if (!isTenantAdmin) {
    return (
      <AppLayout>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold mb-4">Access Denied</h2>
            <p className="text-gray-600">You need Tenant Admin permissions to access this page.</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <PageContainer>
        <PageHeader
          title="Welcome Message"
          description="Set the message displayed to new users or patrons on first login."
          breadcrumbItems={[{ label: "Setup", href: "/setup" }, { label: "Welcome Message" }]}
          showSearch={false}
          titleSize="md"
        />

        <Card className="p-6">
          <p className="text-gray-600">
            Welcome message configuration page coming soon. This will allow you to set the message
            displayed to new users or patrons on first login.
          </p>
        </Card>
      </PageContainer>
    </AppLayout>
  );
};

export default WelcomeMessageSettingsPage;
